import Page from '../pages/page';
import LoginPage from '../pages/login-page';
import CartPage from '../pages/cart-page';
import QuickOrderPage from '../pages/quick-order-page';
import OrderTemplateOverviewPage from '../pages/orders/order-template-overview-page';
import OrderTemplateDetailPage from '../pages/orders/order-template-detail-page';
import ShippingOrderOverviewPage from '../pages/shipping-order-overview-page';
import TireWarrantyDetailPage from '../pages/tire-warranty/tire-warranty-detail-page';
import TireWarrantySubmittedPage from '../pages/tire-warranty/tire-warranty-submitted-page';
import TireWarrantySavedPage from '../pages/tire-warranty/tire-warranty-saved-page';
import ShippingOrderDetailPage from '../pages/shipping-order-detail-page';
import DeliveryNotePage from '../pages/orders/delivery-note-page';
import InvoicePage from '../pages/orders/invoice-page';
import OutstandingAccountPage from '../pages/orders/outstanding-account-page';
import InitialOrderCartPage from '../pages/initial-order-cart-page';
import InitialOrderCategoryPage from '../pages/initial-order-category-page';
import InitialOrderSplitCartPage from '../pages/initial-order-cart-split-page';
import InitialOrderProductDetailsPage from '../pages/initial-order-product-details-page';
import BackOrderPage from '../pages/orders/back-order-page';
import OrderedItemsPage from '../pages/orders/ordered-items-page';
import WebReturnsOrders from '../pages/web-returns/web-returns-orders';
import WebReturnsAutopartsBuyback from '../pages/web-returns/web-returns-autoparts-buyback';
import OldReturnsCartPage from '../pages/web-returns/old-returns-cart-page';
import NewReturnsCartPage from '../pages/web-returns/new-returns-cart-page';
import WebReturnsOrderDetails from '../pages/web-returns/web-returns-order-details';
import ProductDetailsPage from '../pages/product-details-page';
import DashboardPage from '../pages/dashboard-page';
import TireSearchPage from '../pages/tire-warranty/tire-search-page';
import WebReturnsListPage from '../pages/web-returns/web-returns-list-page';
import OfferDetailsPage from '../pages/orders/offer-details-page';
import WKRDetailsPage from '../pages/orders/wkr-details-page';
import TemplateListPage from '../pages/orders/template-list-page';
import WkrListPage from '../pages/orders/wkr-list-page';
import WebReturnsAutopartsDetails from '../pages/web-returns/web-returns-autoparts-details';
import DocumentStoragePage from '../pages/document-storage-page';
import CustomerAdminPage from '../pages/customer-admin-page';
import ProductListPage from '../pages/product-list-page';
import ReferenceStatisticsPage from "../pages/reference-statistics-page";

const LoaderTemplate = '<div class="js-loading-indicator loading-indicator"></div>';

/* eslint-disable no-shadow */
export enum PageClass {
  Dashboard = 'page-epartsDashboardPage',
  Login = 'page-login',
  Cart = 'page-cartPage',
  QuickOrder = 'page-quickOrderPage',
  OrderTemplateOverview = 'page-epartsOrderTemplatesPage',
  Category = 'page-productList',
  PaintCategory = 'page-ePartsPaintProductList',
  OrderTemplateDetail = 'page-epartsOrderTemplateDetailsPage',
  ShippingOrderOverview = 'page-epartsShippingOrdersPage',
  TireWarrantyForm = 'page-epartsTireWarrantyPage',
  TireWarrantySubmitted = 'page-epartsTireWarrantySubmittedOverviewPage',
  TireWarrantySaved = 'page-epartsTireWarrantySavedOverviewPage',
  ShippingOrderDetail = 'page-epartsShippingOrderDetailsPage',
  DeliveryNote = 'page-epartsDeliveryNotePage',
  Invoice = 'page-epartsInvoicePage',
  OutstandingAccount = 'page-epartsOutstandingAccountPage',
  InitialOrderCart = 'page-epartsInitialOrderCartPage',
  InitialOrderSplitCart = 'page-epartsInitialOrderCartSplitPage',
  InitialOrderCategoryPage = 'page-epartsInitialOrderCategory',
  InitialOrderProductDetailsPage = 'page-epartsInitialOrderProductDetailsPage',
  BackorderPage = 'page-epartsBackorderListPage',
  OrderedItems = 'page-epartsOrderedItemsListPage',
  WebReturnsOrders = 'page-epartsWebReturnsOrdersPage',
  WebReturnsAutoparts = 'page-epartsWebReturnsAutopartsPage',
  WebReturnsAutopartsDetails = 'page-epartsWebReturnsAutopartsDetailsPage',
  WebReturnsBuyback = 'page-epartsWebReturnsBuybacksPage',
  WebReturnsNewParts = 'page-epartsNewReturnsListPage',
  WebReturnsOldParts = 'page-epartsOldReturnsListPage',
  OldReturnsCartPage = 'page-epartsOldReturnsCartPage',
  NewReturnsCartPage = 'page-epartsNewReturnsCartPage',
  WebReturnsOrderDetails = 'page-epartsWebReturnsOrderDetailsPage',
  ProductDetails = 'page-productDetails',
  TireSearch = 'page-epartsTireSearchPage',
  OfferDetails = 'page-epartsOfferDetailsPage',
  OfferList = 'page-epartsOfferListPage',
  WkrList = 'page-epartsWkrListPage',
  WkrDetails = 'page-epartsWkrDetailsPage',
  DocumentStorage = 'page-epartsDocumentStorageMicrositePage',
  CustomerAdmin = 'page-epartsCustomerAdminPage',
  SearchResultsPage = 'page-search',
  ProductListPage = 'page-productList',
  ReferenceStatistics = 'page-epartsReferenceStatisticsPage',
}
/* eslint-enable no-shadow */

export default class PageHelper {

  static initPage(): Page {
    let pageClass = '';
    const classList = document.body.className.split(' ');
    for (let i = 0; i < classList.length; i++) {
      const className = classList[i];
      if (className.startsWith('page-')) {
        pageClass = className;
        break;
      }
    }

    let page: Page;
    const body: JQuery<HTMLBodyElement> = $('body');

    switch (pageClass) {
      case PageClass.PaintCategory:
      case PageClass.ProductListPage:
      case PageClass.SearchResultsPage:
        page = new ProductListPage(body);
        break;
      case PageClass.Dashboard:
        page = new DashboardPage(body);
        break;
      case PageClass.Login:
        page = new LoginPage(body);
        break;
      case PageClass.Cart:
        page = new CartPage(body);
        break;
      case PageClass.QuickOrder:
        page = new QuickOrderPage(body);
        break;
      case PageClass.OrderTemplateOverview:
        page = new OrderTemplateOverviewPage(body);
        break;
      case PageClass.OrderTemplateDetail:
        page = new OrderTemplateDetailPage(body);
        break;
      case PageClass.TireWarrantyForm:
        page = new TireWarrantyDetailPage(body);
        break;
      case PageClass.TireWarrantySubmitted:
        page = new TireWarrantySubmittedPage(body);
        break;
      case PageClass.TireWarrantySaved:
        page = new TireWarrantySavedPage(body);
        break;
      case PageClass.ShippingOrderOverview:
        page = new ShippingOrderOverviewPage(body);
        break;
      case PageClass.ShippingOrderDetail:
        page = new ShippingOrderDetailPage(body);
        break;
      case PageClass.DeliveryNote:
        page = new DeliveryNotePage(body);
        break;
      case PageClass.Invoice:
        page = new InvoicePage(body);
        break;
      case PageClass.OutstandingAccount:
        page = new OutstandingAccountPage(body);
        break;
      case PageClass.InitialOrderCart:
        page = new InitialOrderCartPage();
        break;
      case PageClass.InitialOrderSplitCart:
        page = new InitialOrderSplitCartPage(body);
        break;
      case PageClass.InitialOrderCategoryPage:
        page = new InitialOrderCategoryPage(body);
        break;
      case PageClass.InitialOrderProductDetailsPage:
        page = new InitialOrderProductDetailsPage();
        break;
      case PageClass.BackorderPage:
        page = new BackOrderPage(body);
        break;
      case PageClass.OrderedItems:
        page = new OrderedItemsPage(body);
        break;
      case PageClass.WebReturnsOrders:
        page = new WebReturnsOrders(body);
        break;
      case PageClass.WebReturnsAutoparts:
        page = new WebReturnsAutopartsBuyback(body);
        break;
      case PageClass.WebReturnsBuyback:
        page = new WebReturnsAutopartsBuyback(body);
        break;
      case PageClass.WebReturnsNewParts:
        page = new WebReturnsListPage(body);
        break;
      case PageClass.WebReturnsOldParts:
        page = new WebReturnsListPage(body);
        break;
      case PageClass.OldReturnsCartPage:
        page = new OldReturnsCartPage(body);
        break;
      case PageClass.NewReturnsCartPage:
        page = new NewReturnsCartPage(body);
        break;
      case PageClass.WebReturnsOrderDetails:
        page = new WebReturnsOrderDetails(body);
        break;
      case PageClass.WebReturnsAutopartsDetails:
        page = new WebReturnsAutopartsDetails(body);
        break;
      case PageClass.ProductDetails:
        page = new ProductDetailsPage(document.body as HTMLBodyElement);
        break;
      case PageClass.TireSearch:
        page = new TireSearchPage(body);
        break;
      case PageClass.OfferDetails:
        page = new OfferDetailsPage(document.body as HTMLBodyElement);
        break;
      case PageClass.WkrDetails:
        page = new WKRDetailsPage(document.body as HTMLBodyElement);
        break;
      case PageClass.OfferList:
        page = new TemplateListPage(body);
        break;
      case PageClass.WkrList:
        page = new WkrListPage(body);
        break;
      case PageClass.DocumentStorage:
        page = new DocumentStoragePage(document.body as HTMLBodyElement);
        break;
      case PageClass.CustomerAdmin:
        page = new CustomerAdminPage(document.body as HTMLBodyElement);
        break;
      case PageClass.ReferenceStatistics:
        page = new ReferenceStatisticsPage(body);
        break;
      default:
        page = new Page();
    }

    if (typeof page.init === 'function') {
      page.init();
    }
    return page;
  }

  static showLoadingIndicator(): void {
    $('body').append(LoaderTemplate);
    $('body').addClass('is-loading');
  }

  static clearLoadingIndicator(): void {
    $('body').find('.js-loading-indicator').remove();
    $('body').removeClass('is-loading');
  }

  static isInitialOrderPage(): boolean {
    return $('body').hasClass(PageClass.InitialOrderCart)
      || $('body').hasClass(PageClass.InitialOrderCategoryPage)
      || $('body').hasClass(PageClass.InitialOrderProductDetailsPage)
      || $('body').hasClass(PageClass.InitialOrderSplitCart);
  }
}
